module.exports = __webpack_public_path__ + "img/welcome.bbde696d.jpeg";